<template>
	<div>
		<HeaderBar title="影像检查"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="肝脏超声异常">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq400yxx.bq400244}}</span>
							<span v-show="form.bq400yxx.bq400244=='有'">
								<van-tag type="danger" class="followRecord-tag">{{form.bq400yxx.bq4002442}}
								</van-tag>
							</span>
						</template>
					</van-cell>
					<FormNormalUpload label="肝脏超声异常报告" ref="normalUploadBQ400244" :infoGuid='form.bq400yxx.guid'
						type="bq400244" disabled>
					</FormNormalUpload>
				</van-cell-group>

				<van-cell-group title="腹部CT异常">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq400yxx.bq400245}}</span>
							<span v-show="form.bq400yxx.bq400245=='有'">
								<van-tag type="danger" class="followRecord-tag">{{form.bq400yxx.bq4002452}}
								</van-tag>
							</span>
						</template>
					</van-cell>
					<FormNormalUpload label="腹部CT异常报告" ref="normalUploadBQ400245" :infoGuid='form.bq400yxx.guid'
						type="bq400245" disabled>
					</FormNormalUpload>
				</van-cell-group>


				<van-cell-group title="腹部磁共振异常">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq400yxx.bq400246}}</span>
							<span v-show="form.bq400yxx.bq400246=='有'">
								<van-tag type="danger" class="followRecord-tag">{{form.bq400yxx.bq4002462}}
								</van-tag>
							</span>
						</template>
					</van-cell>
					<FormNormalUpload label="腹部磁共振异常" ref="normalUploadBQ400246" :infoGuid='form.bq400yxx.guid'
						type="bq400246" disabled>
					</FormNormalUpload>
				</van-cell-group>

				<van-cell-group title="肝脏硬度检查">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq400yxx.bq400247}}</span>
							<span v-show="form.bq400yxx.bq400247!=''">
								<van-tag type="danger" class="followRecord-tag">肝脏硬度:{{form.bq400yxx.bq4002472}}kPa
								</van-tag>
								<van-tag type="danger" class="followRecord-tag">脂肪衰减:{{form.bq400yxx.bq4002473}}dB/m
								</van-tag>
							</span>
						</template>
					</van-cell>
					<FormNormalUpload label="肝脏硬度检查" ref="normalUploadBQ400247" :infoGuid='form.bq400yxx.guid'
						type="bq400247" disabled>
					</FormNormalUpload>
				</van-cell-group>

				<van-cell-group title="肝脏病理检查">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq400yxx.bq400248}}</span>
							<span v-show="form.bq400yxx.bq400248!=''">
								<van-tag type="danger" class="followRecord-tag">炎症分级:{{form.bq400yxx.bq4002482}}
								</van-tag>
								<van-tag type="danger" class="followRecord-tag">纤维化分期:{{form.bq400yxx.bq4002483}}
								</van-tag>
								<van-tag type="danger" class="followRecord-tag">脂肪变分级:{{form.bq400yxx.bq4002484}}
								</van-tag>
								<van-tag type="danger" class="followRecord-tag">病理结论:{{form.bq400yxx.bq4002485}}
								</van-tag>
							</span>
						</template>
					</van-cell>
					<FormNormalUpload label="肝脏病理检查" ref="normalUploadBQ400248" :infoGuid='form.bq400yxx.guid'
						type="bq400248" disabled>
					</FormNormalUpload>
				</van-cell-group>

			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page010",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400yxx',
				form: {
					bq400yxx: {
						id: "", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400240: "", //肝脏瞬时弹性成像
						bq400241: "", //Stiffness(KPa)
						bq400242: "", //CAP(dB/m)
						bq400243: "", //检查日期
						bq400244: "", //腹部超声异常 有，无
						bq4002442: "", //异常描述
						bq4002443: "", //检查日期
						bq400245: "", //腹部CT异常 有、无
						bq4002452: "", //异常描述
						bq4002453: "", //检查日期
						bq400246: "", //腹部MR异常 有、无
						bq4002462: "", //异常描述
						bq4002463: "", //检查日期
						bq400247: "", //肝脏硬度类型
						bq4002472: "", //肝脏硬度kPa
						bq4002473: "", //脂肪衰减dB/m
						bq400248: "", //肝脏病理检查
						bq4002482: "", //炎症分级
						bq4002483: "", //纤维化分期
						bq4002484: "", //脂肪变分级
						bq4002485: "", //病理结论
						Bq400_guid: '', //随访基本信息表编号
						Bq400_240: '', //肝脏瞬时弹性成像
						Bq400_241: '', //Stiffness(KPa)
						Bq400_242: '', //CAP(dB/m)
						Bq400_243: '', //检查日期
						Bq400_244: '', //腹部超声异常 有，无
						Bq400_244_2: '', //异常描述
						Bq400_244_3: '', //检查日期
						Bq400_245: '', //腹部CT异常 有、无
						Bq400_245_2: '', //异常描述
						Bq400_245_3: '', //检查日期
						Bq400_246: '', //腹部MR异常 有、无
						Bq400_246_2: '', //异常描述
						Bq400_246_3: '', //检查日期
						Bq400_247: '', //肝脏硬度类型
						Bq400_247_2: '', //肝脏硬度kPa
						Bq400_247_3: '', //脂肪衰减dB/m
						Bq400_248: '', //肝脏病理检查
						Bq400_248_2: '', //炎症分级
						Bq400_248_3: '', //纤维化分期
						Bq400_248_4: '', //脂肪变分级
						Bq400_248_5: '', //病理结论
					},
					sempFiles: []
				},
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400yxx/Save',
				bq400: JSON.parse(sessionStorage.getItem('bq400')) //获取随访信息
			}
		},
		components: {
			...componentsModel,

		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400yxx/Info', args, function(d) {
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq400yxx)
				}, null, null, null);
			},
			//重新整理数据
			ResetData: function() {
				if (this.form.bq400yxx.bq400244 == '无') {
					this.form.bq400yxx.bq4002442 = ''
				}
				if (this.form.bq400yxx.bq400245 == '无') {
					this.form.bq400yxx.bq4002452 = ''
				}
				if (this.form.bq400yxx.bq400246 == '无') {
					this.form.bq400yxx.bq4002462 = ''
				}
				if (this.form.bq400yxx.bq400246 == '无') {
					this.form.bq400yxx.bq4002462 = ''
				}
				if (this.form.bq400yxx.bq400247 == '') {
					this.form.bq400yxx.bq4002472 = ''
					this.form.bq400yxx.bq4002473 = ''
				}
				if (this.form.bq400yxx.bq400248 == '') {
					this.form.bq400yxx.bq4002482 = ''
					this.form.bq400yxx.bq4002483 = ''
					this.form.bq400yxx.bq4002484 = ''
					this.form.bq400yxx.bq4002485 = ''
				}
			},
			//保存信息
			SaveInfo: function() {
				let that = this
				that.ResetData()
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			let that = this
			that.form.bq400yxx.bq400guid = that.bq400.guid
			console.log(that.form.bq400yxx.bq400guid);
			that.LoadInfo()
		}
	}
</script>

<style scoped>
	.followRecord-title {
		padding-right: 10px;
	}

	.followRecord-tag {
		margin-right: 10px;
	}
</style>
